<template  v-bind:dir="direction">
  <div class="main-wrapper">
    <div id="mainChatLogin" class="container">
      <div id="userInfoSection" class="row" style="display: block;">
        <div class="panel" style="display: block;">
          <div id="chatContainer" class="panel-body p10-outer-f">
            <div v-if="isRtaWebChatBot">
              <div id="cross-anchor" style="">
                <a href="#" onclick="window.parent.postMessage(JSON.stringify({close : 'true'}), '*');" class="close-sticky close-question" id="cross">×</a>
              </div>
              <h3 id="heading" class=""> RTA Online Chat </h3>
            </div>
            <div v-if="RtaAppPath==='RtaAppChatBot'">
              <div id="cross-anchor" style="">

              </div>
              <div id="closeOption" class="close-option-login">
                <a href="/RtaAppChatBot/jsp/chat/closewindow.jsp" onclick="window.parent.postMessage(JSON.stringify({close : 'true'}), '*');" class="close-option-login" id="cross"><img src="../assets/images/cross-button.png" width="21px"></a>
              </div>
            </div>
            <div v-if="!isRtaWebChatBot">
              <div class="custmerinfo-close">
                <div class="left clearfix custom-background bigger-txt">{{ labels['chatbox.USERFORM_MSG'] }}</div>
              </div>
              <div style="height: 5px;"></div>
              <div class="left clearfix custom-background norm-txt">{{ labels['chatbox.USERFORMLOGIN_MSG'] }}</div>
              <div class="left clearfix custom-background">
                <span class="small-grey">{{ labels['chatbox.USERFORMREQUIRED_MSG'] }}</span>
              </div>
            </div>
            <form @submit.prevent="submit">
              <ul id="chatMessages" class="form">
                <li class="left clearfix custom-background">
                  <div class="black-txt" id="nameTxt" v-if="!$v.name.$error && submitStatus!='ERROR' && !isRtaWebChatBot">{{ labels['chatbox.NAME_TEXT'] }}</div>
                  <div class="red-txt" id="nameError" v-if="$v.name.$error || submitStatus=='ERROR'">
                    <div v-if="!$v.name.required ">{{ labels['chatbox.NAME_REQUIRED_ERROR_TEXT'] }}</div>
                  </div>
                  <div class="chat-body clearfix">
                    <div class="header">
                      <app-input aria-colcount="10" aria-rowcount="10" id="name" v-model="name" :status="$v.name.$error ? 'error' : null"
                                 @blur.native="$v.name.$touch()" :placeholder="enterNamePlaceholder"></app-input>
                    </div>
                  </div>
                </li>
                <li class="left clearfix custom-background">
                  <div class="black-txt" id="emailTxt" v-if="!$v.email.$error && submitStatus!='ERROR'  && !isRtaWebChatBot">{{ labels['chatbox.EMAIL_TEXT'] }}</div>
                  <div class="red-txt" id="emailError" v-if="$v.email.$error || submitStatus=='ERROR'">
                    <div v-if="!$v.email.required">{{ labels['chatbox.EMAIL_REQUIRED_ERROR_TEXT'] }}</div>
                    <div v-if="!$v.email.email">{{ labels['chatbox.EMAIL_ADDRESS_INVALID_ERROR_TEXT'] }}</div>
                  </div>
                  <div class="chat-body clearfix">
                    <div class="header">
                      <app-input id="email" type="email" v-model="email" :status="$v.email.$error ? 'error' : null"
                                 @blur.native="$v.email.$touch()" :placeholder="enterEmailPlaceholder"></app-input>
                    </div>
                  </div>
                </li>
                <li class="left clearfix custom-background">
                  <div class="black-txt" id="phoneTxt" v-if="!$v.phone.$error && submitStatus!='ERROR' && !isRtaWebChatBot">{{ labels['chatbox.PHONE_TEXT'] }}</div>
                  <div class="red-txt" id="phoneError" v-if="$v.phone.$error || submitStatus=='ERROR'">
                    <div v-if="!$v.phone.required">{{ labels['chatbox.PHONE_NUMBER_NULL_ERROR_TEXT'] }}</div>
                    <div v-if="!$v.phone.minLength">{{ labels['chatbox.PHONE_NUMBER_INVALID_ERROR_TEXT1'] }}</div>
                  </div>
                  <div class="chat-body clearfix">
                    <div class="header">
                      <div class="mob-field1" id="countryCodeDiv" style="width:48%;">
                        <v-select :options="numberCodes" v-model="selectedNumberCode" label="countryName"
                                  @input="changedSelectedNumberCode" :clearable="false" append-to-body></v-select>
                      </div>
                      <div v-if="selectedNumberCode.countryCode == 971" class="mob-field2" id="number"
                           :style="[isRtaWebChatBot ? {'width':'20%', 'padding-top':'7px', 'margin-right':'0px', 'float':'left'} : {'width':'20%', 'padding-top':'7px', 'padding-left':'15px', 'float':'left'}]">
                        <v-select :options="numberCodesUAE" v-model="selectedNumberCodeUAE" label="code"
                                  :clearable="false" append-to-body></v-select>
                      </div>
                      <div class="mob-field3" id="mobField" :style="[isRtaWebChatBot ? {'width':'32%', 'height':'35px', 'padding-top':'7px', 'float':'left', 'margin-right':'0%'} : {'width':'27%', 'padding-top':'7px'}]">
                        <!--<app-input id="phone" type="number" v-model="phone"
                                    :status="$v.phone.$error ? 'error' : null"
                                    @blur.native="$v.phone.$touch()" :placeholder="enterPhonePlaceholder"
                                    :maxlength="(selectedNumberCode.countryCode == 971?7:12)"
                                    :minlength="(selectedNumberCode.countryCode == 971?7:9)"
                         ></app-input>-->
                        <input type="text" id="phone" v-model="phone"
                               v-bind:class="$v.phone.$error ? 'AppInput has-status-error' : 'AppInput'"
                               @blur="$v.phone.$touch()" :placeholder="enterPhonePlaceholder"
                               :maxlength="(selectedNumberCode.countryCode == 971?7:12)"
                               :minlength="(selectedNumberCode.countryCode == 971?7:9)">
                      </div>
                    </div>
                  </div>
                </li>
                <li class="left clearfix custom-background">
                  <div v-if="!isRtaWebChatBot" class="black-txt" id="langTxt">{{ labels['chatbox.LANG_TEXT'] }}</div>
                  <div class="chat-body clearfix">
                    <div class="header">
                      <v-select :options="languages" v-model="selectedLanguage" label="name"
                                v-bind:class="{ disabled: isSkillsetDisabled() }" @input="changedSelectedLanguage"
                                :clearable="false" append-to-body></v-select>
                    </div>
                  </div>
                </li>
                <li class="left clearfix custom-background" id="defaultskill">
                  <div class="black-txt" id="subjectTxt"  v-if="selectedSkillset.code !='' && submitStatus!='ERROR' && !isRtaWebChatBot">{{ labels['chatbox.SUBJECT_TEXT'] }}</div>
                  <div class="red-txt" id="subjectError"  v-if="selectedSkillset.code =='' && submitStatus=='ERROR'">{{ labels['chatbox.CHAT_TOPIC_REQUIRED_ERROR_TEXT'] }}</div>
                  <div class="chat-body clearfix">
                    <div class="header">
                      <v-select :options="skillsets" v-model="selectedSkillset" label="name"
                                v-bind:class="{ disabled: isSkillsetDisabled() }"
                                :placeholher="enterSkillsetPlaceholder" :clearable="false" append-to-body></v-select>
                    </div>
                  </div>
                  <br>
                </li>
                <li>
                  <div v-if="greCaptchaIsActive" class="g-recaptcha"><Recaptcha  @validate="validate"/></div>
                </li>
                <li class="left clearfix custom-background">
                  <div class="red-txt" id="blacklistError"  v-if="blacklistErrorText !='' && submitStatus=='ERROR'">{{ blacklistErrorText }}</div>
                  <div class=" ">
                    <button :disabled="!isFormValid" type="submit" style="color:white !important" id="startButton"
                            class="btn  start-btn">{{ labels['chatbox.SUBMIT_BUTTON_TEXT'] }}
                    </button>
                  </div>
                </li>
              </ul>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div id="chat" style="display:none" >
      <chat/>
    </div>

  </div>
</template>

<script>
import {email, required, minLength,maxLength} from 'vuelidate/lib/validators';
import formMixin from '../utils/form';
import AppInput from './AppInput';
import Chat from './Chat';
import Utilities from '../assets/js/chat/utilities'
import http from "../http-common"
import Vue from 'vue'
import $ from 'jquery'

import ChatLogon from '../assets/js/chat/webChatLogon'
import Recaptcha from './Recaptcha'

export default {
  name: 'CustomerLogin',
  mixins: [formMixin],
  components: {
    AppInput,
    chat: Chat,
    Recaptcha
  },
  data() {
    return {
      skillsets: [],
      allSkillSets: [],
      lang: this.$route.query.lang,
      name: (this.$route.query.name == "undefined" ||this.$route.query.name ==null)?"":this.$route.query.name,
      email: (this.$route.query.email == "undefined" ||this.$route.query.email ==null)?"":this.$route.query.email ,
      enterNamePlaceholder: "",
      enterEmailPlaceholder: "",
      enterPhonePlaceholder: "",
      enterSkillsetPlaceholder: "",
      phone: "",
      numberCodes: [],
      numberCodesUAE: [],
      languages: [],
      selectedNumberCodeUAE: {code: ""},
      selectedNumberCode: {countryName: "", countryCode: ""},
      selectedLanguage: null,
      selectedSkillset: {name: "", code: "", attributes: ""},
      labels: Vue.prototype.$labels,
      isRtaWebChatBot: Vue.prototype.$RtaWebChatBot,
      phoneFields: null,
      direction : (this.$route.query.lang === "en" ? "ltr": "rtl"),
      submitStatus: "",
      RtaAppPath : Vue.prototype.$RtaAppPath,
      minLength: 3,
      valName: "validatorName",
      validateRecaptcha: !Vue.prototype.$config.grecaptchaIsActive,
      greCaptchaIsActive: Vue.prototype.$config.grecaptchaIsActive,
      phoneBlacklisted: false,
      emailBlacklisted: false,
      blacklistErrorText: "",
    }
  },
  validations() {
    return{
      name: {
        required
      },
      email: {
        required,
        email,
      },
      phone: {
        required,
        minLength: this.selectedNumberCode.countryCode == '971' ? minLength(7) : minLength(9),
        maxLength: this.selectedNumberCode.countryCode == '971' ? maxLength(7) : maxLength(12),
      }
    }
  },
  mounted() {
    this.enterNamePlaceholder = this.labels['chatbox.ENTER_NAME_TEXT'];
    this.enterEmailPlaceholder = this.labels['chatbox.ENTER_EMAIL_TEXT'];
    this.enterPhonePlaceholder = this.labels['chatbox.ENTER_PHONE_TEXT'];
    this.enterSkillsetPlaceholder = this.labels['chatbox.SELECT_TOPIC'];
    this.channel = Vue.prototype.$channel;

    this.setPhoneInputFilter()
    this.loadInitial()

  },
  computed: {
    isFormValid() {

      let isValid = false;

      isValid = Utilities.isNameAndEmailAndPhoneValid(this.getCustDetails(this.name, this.email, this.selectedNumberCode.countryCode, this.selectedNumberCodeUAE.code, this.phone), this.numberCodes) && this.selectedSkillset.code !='' && this.validateRecaptcha
      if (!(Vue.prototype.$color === "undefined" || Vue.prototype.$color === null) && document.getElementById("startButton")) {
        if(isValid) {
          document.getElementById("startButton").style.backgroundColor = Vue.prototype.$color;
          document.getElementById("startButton").style.borderColor = Vue.prototype.$color;

        } else {
          document.getElementById("startButton").style.backgroundColor = Vue.prototype.$disableColor;
          document.getElementById("startButton").style.borderColor = Vue.prototype.$disableColor;
        }
      }

      return isValid;
    }
  },
  methods: {
    validate (success) {
      this.validateRecaptcha = success
    },
    acceptNumber() {
      var x = this.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    },
    onInput($event) {
      $event.preventDefault();
    },
    updateValue(event) {
      const value = event
      if (String(value).length <= 7) {
        this.phone = value;
      } else {
        event.preventDefault();
      }
      this.$forceUpdate()
    },
    isNumber() {

      ///^-?\d*$/.test(value)
      var oldValue = this.phone;
      for(var i=0; i<this.phone.length; i++) {
        console.log('this.phone.charAt(i):',this.phone.charAt(i));
        console.log('oldValue:',oldValue);

        if (!(/[0-9]/.test(this.phone.charAt(i)))) {
          if(oldValue.length == 1) {
            this.phone = '';
          } else if(oldValue.length > 1) {
            this.phone = oldValue.slice(0, -1);
          }
        }

      }

      /*event = (event) ? event : window.event;
      var charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode == 46) {
        event.preventDefault();
      } else {
        return true;
      }*/
    },
    setPhoneInputFilter() {
      ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop", "focusout"].forEach(function(event) {
        document.getElementById("phone").addEventListener(event, function(e) {
          if (/^\d*$/.test(this.value)) {
            // Accepted value
            if (["keydown","mousedown","focusout"].indexOf(e.type) >= 0){
              this.setCustomValidity("");
            }
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
          } else if (Object.prototype.hasOwnProperty.call(this, "oldValue")) {
            // Rejected value - restore the previous one
            this.value = document.getElementById("phone").oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
          } else {
            // Rejected value - nothing to restore
            this.value = "";
          }
        });
      });
    },
    loadInitial() {
      //this.loadSkillsets()
      this.loadEnabledNumberCodes()
      //this.loadEnabledNumberCodesForUAE()
      this.loadLanguages()
    },
    isSkillsetDisabled() {
      var disabled = false;
      if (this.selectedSkillset.code != 'undefined' && this.selectedSkillset.code != null && this.selectedSkillset.code != "" && this.$route.query.skillset != undefined && this.$route.query.skillset != null && this.$route.query.skillset != "") {
        disabled = true;
      }
      return disabled;
    },
    setPhoneFieldsFromQueryString(numberCodes) {
      this.phoneFields = Utilities.extractPhoneFields(this.$route.query.phone, numberCodes, null);

      if (this.phoneFields.isUAE) {
        this.setSelectedNumberCode("971");
        this.selectedNumberCodeUAE.code = this.phoneFields.area;
        this.phone = this.phoneFields.phone;
      } else {
        this.setSelectedNumberCode(this.phoneFields.countryCode);
        this.changedSelectedNumberCode(this.selectedNumberCode);
        this.phone = this.phoneFields.phone;
      }
    },
    loadSkillsets() {
      http
          .get("/getSkillsetsByChannel", {params: {channel: this.channel}})
          .then(response => {
            var placeholder = {
              attributes: "",
              channel: this.channel,
              code: "",
              enabled: 0,
              id: 0,
              lang: this.lang,
              name: this.labels['chatbox.SELECT_TOPIC'],
              orderBy: 1
            }
            response.data.unshift(placeholder);
            this.allSkillsets = response.data;
            this.skillsets = this.getSkillSetsByLang(this.allSkillsets)
            this.selectedSkillset = this.skillsets[0];
            var custDetails = this.getCustDetails(this.name, this.email, this.selectedNumberCode.countryCode, this.selectedNumberCodeUAE.code, this.phone);
            if (this.$route.query.skillset != undefined && this.$route.query.skillset != null && this.$route.query.skillset != "") {
              this.setSelectedSkillset(this.$route.query.skillset);
            } else if (Utilities.isNameAndEmailAndPhoneValid(custDetails, this.numberCodes)) {
              this.loadRegisteredCustomerskillset();
            }

          })
          .catch(e => {
            console.log(e);
          });
    },
    getSkillSetsByLang(skillsets){
      var skillsetArray = [];
      var i=0;
      for(i=0; i<skillsets.length; i++) {

        if(skillsets[i].lang == this.lang) {
          skillsetArray.push(skillsets[i]);
        }

      }
      return skillsetArray;
    },
    loadRegisteredCustomerskillset() {
      http
          .get("/registeredCustomerSkillset", {
            params: {
              lang: this.lang,
              channel: Vue.prototype.$channel,
              appname: Vue.prototype.$appname
            }
          })
          .then(response => {
            this.setSelectedSkillset(response.data.code);
          })
          .catch(e => {
            console.log(e);
          });
    },
    setSelectedSkillset(code) {
      var i = 0;
      for (i = 0; i < this.skillsets.length; i++) {
        if (this.skillsets[i].code == code) {
          this.selectedSkillset = this.skillsets[i];
          if (Utilities.isNameAndEmailAndPhoneValid(this.getCustDetails(this.name, this.email, this.selectedNumberCode.countryCode, this.selectedNumberCodeUAE.code, this.phone), this.numberCodes) && !this.$route.query.isLangChange) {
            this.submit();
          }
          break;
        }
      }
    },
    loadEnabledNumberCodesForUAE() {
      http
          .get("/getEnabledNumberCodesForUAE", {params: {lang: this.lang}})
          .then(response => {
            this.numberCodesUAE = response.data;
            if (this.$route.query.phone == 'undefined' || this.$route.query.phone == null || this.$route.query.phone == "") {
              this.selectedNumberCodeUAE = this.numberCodesUAE[0];
            } else {
              var i = 0;
              var areaFound = false;
              for (i = 0; i < this.numberCodesUAE.length; i++) {
                if (this.numberCodesUAE[i].code == this.selectedNumberCodeUAE.code) {
                  areaFound = true;
                  // this.selectedLanguage = this.languages[i];
                  break;
                }
              }
              if (!areaFound) {
                this.selectedNumberCodeUAE.code = "";
              }
            }
            this.loadSkillsets()
          })
          .catch(e => {
            console.log(e);
          });
    },
    loadEnabledNumberCodes() {
      http
          .get("/getEnabledNumberCodes", {params: {lang: this.lang}})
          .then(response => {
            this.numberCodes = response.data;
            if (this.$route.query.phone != 'undefined' && this.$route.query.phone != null && this.$route.query.phone != '') {
              this.setPhoneFieldsFromQueryString(this.numberCodes);
            } else {
              this.setSelectedNumberCode("971");
            }
            this.loadEnabledNumberCodesForUAE()

          })
          .catch(e => {
            console.log(e);
          });
    },
    setSelectedNumberCode(code) {
      var i = 0;
      for (i = 0; i < this.numberCodes.length; i++) {
        if (this.numberCodes[i].countryCode == code) {
          this.selectedNumberCode = this.numberCodes[i];
          break;
        }
      }
    },
    loadLanguages() {
      http
          .get("/getAllLangs")
          .then(response => {
            this.languages = response.data;
            var i = 0;
            for (i = 0; i < this.languages.length; i++) {
              if (this.languages[i].code == this.lang) {
                this.selectedLanguage = this.languages[i];
                break;
              }
            }
          })
          .catch(e => {
            console.log(e);
          });
    },
    async loadChatBlacklist() {
      await http
          .get("/getChatBlacklist", {params: {phone: Vue.prototype.$phone, email: Vue.prototype.$email}})
          .then(response => {
            let blacklist = response.data;
            this.phoneBlacklisted = false;
            this.emailBlacklisted = false;
            for(let i=0; i<blacklist.length; i++) {
              if(blacklist[i].phone === Vue.prototype.$phone){
                this.phoneBlacklisted = true;
              }
              if(blacklist[i].email === Vue.prototype.$email){
                this.emailBlacklisted = true;
              }
            }
            this.blacklistErrorText = "";
            if(this.phoneBlacklisted&&this.emailBlacklisted) {
              this.blacklistErrorText = this.labels['chatbox.CHAT_PHONE_NUMBER_EMAIL_BLACKLISTED'];
            } else if(this.phoneBlacklisted) {
              this.blacklistErrorText = this.labels['chatbox.CHAT_PHONE_NUMBER_BLACKLISTED'];
            } else if(this.emailBlacklisted) {
              this.blacklistErrorText = this.labels['chatbox.CHAT_EMAIL_BLACKLISTED'];
            }
          })
          .catch(e => {
            console.log(e);
          });
    },
    async submit() {
      var phoneSTRTemp = this.selectedNumberCode.countryCode + (this.selectedNumberCode.countryCode == "971"?this.selectedNumberCodeUAE.code :"") + this.phone;
      Vue.prototype.$name = this.name;
      Vue.prototype.$email=  this.email;
      Vue.prototype.$phone = phoneSTRTemp;

      var custDetails = this.getCustDetails(this.name, this.email, this.selectedNumberCode.countryCode, this.selectedNumberCodeUAE.code, this.phone);
      this.phoneFields = Utilities.extractPhoneFields(phoneSTRTemp, this.numberCodes, this.selectedNumberCode.countryCode);
      if (!Utilities.isNameAndEmailAndPhoneValid(custDetails, this.numberCodes) || this.selectedSkillset.code =='' || !this.validateRecaptcha) {
        this.submitStatus = 'ERROR'
        document.getElementById("startButton").style.backgroundColor = Vue.prototype.$disableColor;
        document.getElementById("startButton").style.borderColor = Vue.prototype.$disableColor;
        return;
      } else {

        await this.loadChatBlacklist()
        if(this.blacklistErrorText !='') {
          this.submitStatus = 'ERROR'
          document.getElementById("startButton").style.backgroundColor = Vue.prototype.$disableColor;
          document.getElementById("startButton").style.borderColor = Vue.prototype.$disableColor;
          return;
        }
        document.getElementById("startButton").style.backgroundColor = Vue.prototype.$color;
        document.getElementById("startButton").style.borderColor = Vue.prototype.$color;

        $("#mainChatLogin").hide();
        $("#chat").show();

        this.showChatLoginComponent = false;
        this.showChatComponent = true;
        var config = Vue.prototype.$config;
        ChatLogon.gatherDetails(custDetails, this.selectedSkillset, config);
      }
    },
    getCustDetails(name, email, countryCode, area, number) {
      //console.log("countryCode:", countryCode)
      //console.log("Vue.prototype.$phone:", Vue.prototype.$phone)
      var l_user = name;
      var l_user_last = " ";
      var userNameSpaceIndex = (name != 'undefined' && name != null) ? name.indexOf(" ") : -1;
      if (userNameSpaceIndex > 0) {
        l_user = this.name.substring(0, userNameSpaceIndex);
        l_user_last = this.name.substring(userNameSpaceIndex + 1, this.name.length);
      }

      var custDetails = {
        "firstName": l_user,
        "lastName": l_user_last,
        "email": email,
        "phone": {
          "country": countryCode,
          "area": area,
          "number": number
        }
      };
      return custDetails;
    },
    changedSelectedNumberCode(event) {
      if (event.countryCode != 971) {
        if(this.isRtaWebChatBot) {
          $("#countryCodeDiv").css({width: "64%"});
        } else {
          $("#countryCodeDiv").css({width: "61%"});
        }

      } else {
        if(this.isRtaWebChatBot) {
          $("#countryCodeDiv").css({width: "48%"});
        } else {
          $("#countryCodeDiv").css({width: "45%"});
        }
      }
    },
    changedSelectedLanguage(event) {
      this.lang = event.code;
      this.selectedLanguageIsChanged = true;
      this.skillsets = this.getSkillSetsByLang(this.allSkillsets)

      var redirLocation = window.location.origin + window.location.pathname
          + "?lang=" + this.lang
          + "&name=" + (this.name == "undefined" || this.name == null?"":this.name)
          + "&email=" + (this.email == "undefined" || this.email == null ?"":this.email)
          + "&mobile=" + (this.$route.query.mobile === "false" ? "false" : "true")
          + (this.phone === "" ?"":"&phone=" + this.selectedNumberCode.countryCode + (this.selectedNumberCode.countryCode === "971" ? this.selectedNumberCodeUAE.code :"") + this.phone)
          + (this.$route.query.appname === "undefined" || this.$route.query.appname == null ? "" : "&appname=" +this.$route.query.appname )
          + (this.$route.query.ver === "undefined" || this.$route.query.ver == null ? "" : "&ver=" +  this.$route.query.ver )
          + "&isLangChange=" + true;
      window.removeEventListener('beforeunload', this.beforeWindowUnload)
      window.location.replace(redirLocation);

    }

  }
}
</script>
<style>
.disabled {
  pointer-events: none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  background-color: #eef1f6;
  border-color: #d1dbe5;
}
.v-select .vs__selected-options {
  flex-wrap: nowrap;
  width:100%
}

.v-select .vs__search {
  padding: 0px;
  flex-grow: 0;
  z-index: 0;
}

.v-select .vs__search:focus {
  padding: 0px;
  flex-grow: 0;
  z-index: 0;
}

.vs__open-indicator {
  margin: -15px;
}

.g-recaptcha {
  transform:scale(0.77);
  -webkit-transform:scale(0.77);
  transform-origin:0 0;
  -webkit-transform-origin:0 0;
}

/*.form input::placeholder { !* Chrome, Firefox, Opera, Safari 10.1+ *!
  color: #000000 !important;
  opacity: 1; !* Firefox *!
}
.form input:-ms-input-placeholder { !* Internet Explorer 10-11 *!
  color: #000000 !important;
}
.form input::-ms-input-placeholder { !* Microsoft Edge *!
  color: #000000 !important;
}
.phone-input {
  border: 1px solid rgb(205, 205, 205); border-radius: 4px; width: 100%; height: 35px; padding: 7px;
  font-family: RTA;
}
.phone-input-error {
  border: 1px solid red; border-radius: 4px; width: 100%; height: 35px; padding: 7px;
  font-family: RTA;
}*/
.AppInput {
  border: 1px solid rgb(205, 205, 205); border-radius: 4px; width: 100%; height: 33px; padding: 7px;
  font-family: RTA;
}
.AppInput.has-status-error {
  border-color: red;
}
</style>
